<ng-container *ngIf="!firstLoading">
    <div class="modal-header">
        <h4 class="modal-title roboTitle" id="modal-basic-title">{{'invoices.edit.documentData.other.sectionalAvailable' | translate}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body"style="padding: 10px">
        <div style="margin: 0;margin-top: 10px;overflow-x: auto;">
            <table class="table" *ngIf="listSezionali && listSezionali.length > 0">
                <thead>
                    <tr>
                        <th scope="col" style="max-width: 40px; width: 40px;"></th>
                        <th scope="col">{{'invoices.edit.documentData.other.proposedNumbering' | translate}}</th>
                        <th scope="col">{{'invoices.edit.documentData.other.selection' | translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let doc of listSezionali" (click)="doc.selected = true; selectOne(doc)" style="cursor: pointer;">
                        <td>
                            <input type="checkbox" class="form-check-input" style="margin-left: 0;" [(ngModel)]="doc.selected" (ngModelChange)="selectOne(doc)">
                        </td>
                        <td>
                            <h5>{{doc.numerazione}}</h5>
                        </td>
                        <td>
                            <h5>{{doc.sezionale}}</h5>
                        </td>
                    </tr>
                </tbody>    
            </table>
            <ng-container *ngIf="listSezionali && listSezionali.length == 0 && !first && !loading">
                <ngb-toast [autohide]="false" class="warning">
                    <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">
                    {{'general.noResults' | translate}}
                </ngb-toast>
            </ng-container>
            <app-loading *ngIf="loading"></app-loading>
        </div>
    
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="close()">{{ 'general.close' | translate }}</button>
        <button type="button" class="btn btn-outline-dark" (click)="save()">{{ 'general.save' | translate }}</button>
    </div>
</ng-container>

